var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFastfood = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18.3333C5 10.9695 10.9695 5 18.3333 5H21.6667C25.2029 5 28.5943 6.40476 31.0948 8.90524C33.5952 11.4057 35 14.7971 35 18.3333C35 19.2538 34.2538 20 33.3333 20H6.66667C5.74619 20 5 19.2538 5 18.3333ZM33.3333 30H30.5C30.0628 30.0018 29.6438 30.1754 29.3333 30.4833L26.6667 33.0833C26.5102 33.2411 26.2972 33.3298 26.075 33.3298C25.8528 33.3298 25.6398 33.2411 25.4833 33.0833L22.8833 30.4833C22.5729 30.1754 22.1539 30.0018 21.7167 30H6.66667C5.74619 30 5 30.7462 5 31.6667V33.3333C5 34.2538 5.74619 35 6.66667 35H33.3333C34.2538 35 35 34.2538 35 33.3333V31.6667C35 30.7462 34.2538 30 33.3333 30ZM18.8333 23.3333H33.3333C34.2538 23.3333 35 24.0795 35 25V26.6667C35 27.5871 34.2538 28.3333 33.3333 28.3333H6.66667C5.74619 28.3333 5 27.5871 5 26.6667V25C5 24.0795 5.74619 23.3333 6.66667 23.3333H10.1167C10.5539 23.3352 10.9729 23.5088 11.2833 23.8167L13.8167 26.4167C13.9731 26.5744 14.1861 26.6632 14.4083 26.6632C14.6305 26.6632 14.8435 26.5744 15 26.4167L17.6667 23.8167C17.9771 23.5088 18.3961 23.3352 18.8333 23.3333Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFastfood, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fastfood.4ee9f6f7.svg";
export { ForwardRef as ReactComponent };